import { useNavigate, useRouteError } from "react-router-dom"

import { ErrorFallback } from "@/components/common/error-fallback"
import { queryClient } from "@/lib/query-client"

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  const resetErrorBoundary = () => {
    queryClient.clear()
    navigate("/", { replace: true })
  }

  const normalizedError = error instanceof Error ? error : new Error("Unexpected route error")

  return <ErrorFallback error={normalizedError} resetErrorBoundary={resetErrorBoundary} />
}
